import { createJWTAuthorizedAxios } from 'utils/axios';
import { useAppLocale } from '@higo/common/lib/features/Locale';
import { createAcceptLanguageInterceptor } from '@higo/common/lib/ext/axios/interceptors';
import { useMemo } from 'react';

export const useCreateJWTAuthorizedAxios = (token?: string) => {
  const { current: currentLocaleDefinition } = useAppLocale();

  return useMemo(() => {
    if (!token) {
      return undefined;
    }

    const axios = createJWTAuthorizedAxios(token);

    const acceptLanguageInterceptor = createAcceptLanguageInterceptor(
      () => currentLocaleDefinition.code,
    );

    axios.interceptors.request.use(acceptLanguageInterceptor);

    return axios;
  }, [currentLocaleDefinition, token]);
};
